/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( document ).on( 'click', '.program-results .blog__pagination button', function() {
        filterResults( getProgramFilters( $( this ).attr( 'data-value' ) ) );
      } );

      $( document ).on( 'change', '.filter-wrapper input', function() {
        filterResults( getProgramFilters() );
      } );

      $( document ).on( 'submit', 'form', function( e ) {
        e.preventDefault();
      } );

      $( document ).on( 'click', '.clear-filters', function() {
        $( '.filter-wrapper input' ).prop( 'checked', false );
        filterResults( getProgramFilters() );
      } );

      function getProgramFilters( paged = 1 ) {
        $( '.clear-filters-wrapper' ).addClass( 'hidden' );
        $( 'button[data-taxonomy] .amount' ).text( '' );

        const args = {
          paged: paged,
          tax_query: {
            relation: 'AND',
          },
        };

        if ( $( 'input[name="ll_program_interest"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const interests = [];

          $( 'input[name="ll_program_interest"]:checked' ).each( function() {
            interests.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_program_interest = {
            relation: 'OR',
            ll_program_interest: {
              taxonomy: 'll_program_interest',
              field: 'term_id',
              terms: interests,
            },
          };

          $( 'button[data-taxonomy="ll_program_interest"] .amount' ).text( '(' + interests.length + ')' );
        }

        if ( $( 'input[name="ll_program_degree_type"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const degreeTypes = [];

          $( 'input[name="ll_program_degree_type"]:checked' ).each( function() {
            degreeTypes.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_program_degree_type = {
            relation: 'OR',
            ll_program_interest: {
              taxonomy: 'll_program_degree_type',
              field: 'term_id',
              terms: degreeTypes,
            },
          };

          $( 'button[data-taxonomy="ll_program_degree_type"] .amount' ).text( '(' + degreeTypes.length + ')' );
        }

        if ( $( 'input[name="ll_program_department"]:checked' ).length ) {
          $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
          const departments = [];

          $( 'input[name="ll_program_department"]:checked' ).each( function() {
            departments.push( $( this ).attr( 'data-id' ) );
          } );

          args.tax_query.ll_program_department = {
            relation: 'OR',
            ll_program_department: {
              taxonomy: 'll_program_department',
              field: 'term_id',
              terms: departments,
            },
          };

          $( 'button[data-taxonomy="ll_program_department"] .amount' ).text( '(' + departments.length + ')' );
        }

        return args;
      }

      function filterResults( args = [] ) {
        $( '.filter-results, .filter-form' ).addClass( 'is-loading' );
        const data = {
          'args': args,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/programs/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.filter-results' ).html( data.results );
            $( '.filter-results, .filter-form' ).removeClass( 'is-loading' );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'programs', COMPONENT );
} )( app );
